import { HttpClient, HttpParams } from '@angular/common/http';

import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaseView } from '../../models/caseview.model';

export class Value {
  messages: null;
  msgDisplay: number;
  data: {
    appTypeId: null;
    appliedByPostId: null;
    awaitDateValue: null;
    customXidBean: null;
    dbSchema: null;
    delegationVO: null;
    empId: null;
    extendedVO: null;
    langId: null;
    locId: null;
    lstUpdPost: null;
    reason: string;
    recId: null;
    recIdArr: null;
    recNo: string;
    result: null;
    statusId: null;
  };
  errors: null;
}

@Component({
  selector: 'app-reason-for-awaiting',
  templateUrl: './reason-for-awaiting.component.html',
  styleUrls: ['./reason-for-awaiting.component.scss'],
})
export class ReasonForAwaitingComponent implements OnInit {
  response: string;
  value: Value;
  @Input() caseData: any;
  fileId: string;
  appTypeId: string;
  paramsone: any;
  selectedData = [];
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(this.data);
    if (this.data[0] ?.fileId) {
      this.caseData = this.data[0];
      this.fileId = String(
        this.caseData ?.docId ? this.caseData ?.docId : this.caseData ?.fileId
    );
      //this.appTypeId=this.caseData.
      console.log(this.caseData);
      let params = new HttpParams();
      params = params.append('recId', this.fileId);
      params = params.append('appTypeId', '1');
      this.paramsone = params;
    }
    else {
      console.log(this.data);
      this.selectedData.push(this.data);
      console.log(this.selectedData);
      let params = new HttpParams();
      params = params.append('recId', this.selectedData[0].selectedData[0].corrID);
      params = params.append('appTypeId', '3');
      this.paramsone = params;
    }
    // this.caseData = this.data[0];
    // this.fileId = String(
    //   this.caseData ?.docId ? this.caseData ?.docId : this.caseData ?.fileId
    // );
    // //this.appTypeId=this.caseData.
    // console.log(this.caseData);
    // let params = new HttpParams();
    // params = params.append('recId', this.fileId);
    // params = params.append('appTypeId', '1');
    this.http
      .get('/case-mgmnt/reason-for-await', { params: this.paramsone })
      .subscribe((res: Value) => {
        this.value = res;
        console.log('Value', this.value.data.reason);
        this.response = this.value.data.reason;
        console.log('Result :', this.response);
      });
  }

  ngOnInit(): void {
    console.log();
  }
}
